import { render, staticRenderFns } from "./DealerWaitStatusLegend.vue?vue&type=template&id=29a9de8c"
import script from "./DealerWaitStatusLegend.vue?vue&type=script&lang=js"
export * from "./DealerWaitStatusLegend.vue?vue&type=script&lang=js"
import style0 from "./DealerWaitStatusLegend.vue?vue&type=style&index=0&id=29a9de8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports